/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {AccidentPersonType} from "../model/accident-person-type";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AccidentPersonTypeService {

  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/accidentpersontypes';
  }

  getAll(): Observable<AccidentPersonType[]> {
    const url = `${this.baseUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(accidentPersonType => accidentPersonType as AccidentPersonType[]));
  }

  updateAccidentPersonTypeById(accidentPersonType: AccidentPersonType): Observable<AccidentPersonType>{
    const id = accidentPersonType.accidentPersonTypeId;
    const url = `${this.baseUrl}/${id}`;

    return this.http.put(url,accidentPersonType,httpOptions).pipe(
      map(accidentPersonType => accidentPersonType as AccidentPersonType));
  }

  addAccidentPersonType(accidentPersonType: AccidentPersonType): Observable<AccidentPersonType>{
    const url = `${this.baseUrl}`;

    return this.http.post(url,accidentPersonType,httpOptions).pipe(
      map(accidentPersonType => accidentPersonType as AccidentPersonType));
  }
}


